// src/pages/Programs.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./program.css";
import backgroundImage from "../assets/About2.jpg";
import { baseurl } from "./api";

// Assets (images)
import nurturing from "../assets/nurturing.jpeg";
import crafting from "../assets/crafting.jpeg";
import selfworth from "../assets/self-worth.jpeg";
import revitalize from "../assets/revitalize.jpeg";
import unleashing from "../assets/unleasing-leadership.jpeg";
import selfImprovement from "../assets/self-improvement-odyssey.jpeg";
import confidence from "../assets/Comfidance-buster.jpeg";
import ignitingSelfMotivation from "../assets/igniting-self-motivation.jpeg";
import selDescipline from "../assets/self-deciplaned.jpeg";
import igniteYourSpark from "../assets/ignite-your-spark.jpeg";
import selfEfficancy from "../assets/self-efficiancy.jpeg";
import fuelYourInspiration from "../assets/fuel-your-inspiration.jpeg";
import selfEsteem from "../assets/self-esteem-enhancement.jpeg";
import unleashYourPotential from "../assets/unlease-your-potential.jpeg";
import selfAwareness from "../assets/self-wareness.jpeg";
import selfLove from "../assets/self-love.jpeg";
import selfRealization from "../assets/self-realization.jpeg";
import exploringSelf from "../assets/exploring-self.jpeg";
import growthBuilt from "../assets/GrowthBuilt.jpeg";
import masteryInInterview from "../assets/masteryinterview.jpeg";
import aceYouEngineering from "../assets/AceYourEnginnering.jpeg";
import exclusiveTailored from "../assets/ExclusiveTailored.jpeg";
import timeManagement from "../assets/timeManagement.jpeg";

const PROGRAMS_META = [
  { id: "674019611d6ab1bd1c9c1bc1", image: nurturing, route: "/program-details" },
  { id: "674019a01d6ab1bd1c9c1bc3", image: crafting, route: "/program2" },
  { id: "674019e01d6ab1bd1c9c1bc5", image: selfworth, route: "/program3" },
  { id: "67401a211d6ab1bd1c9c1bc7", image: revitalize, route: "/program4" },
  { id: "67401a441d6ab1bd1c9c1bc9", image: unleashing, route: "/program5" },
  { id: "67401a6c1d6ab1bd1c9c1bcb", image: selfImprovement, route: "/program6" },
  { id: "67401a921d6ab1bd1c9c1bcd", image: confidence, route: "/program7" },
  { id: "67401ab11d6ab1bd1c9c1bcf", image: ignitingSelfMotivation, route: "/program8" },
  { id: "67401ad11d6ab1bd1c9c1bd1", image: selDescipline, route: "/program9" },
  { id: "67401d321d6ab1bd1c9c1bd3", image: igniteYourSpark, route: "/program10" },
  { id: "67401d5b1d6ab1bd1c9c1bd5", image: selfEfficancy, route: "/program11" },
  { id: "67401d791d6ab1bd1c9c1bd7", image: fuelYourInspiration, route: "/program12" },
  { id: "67401d9a1d6ab1bd1c9c1bd9", image: selfEsteem, route: "/program13" },
  { id: "67401dcb1d6ab1bd1c9c1bdb", image: unleashYourPotential, route: "/program14" },
  { id: "67401dee1d6ab1bd1c9c1bdd", image: selfAwareness, route: "/program15" },
  { id: "67401e111d6ab1bd1c9c1bdf", image: selfLove, route: "/program16" },
  { id: "67401e3a1d6ab1bd1c9c1be1", image: selfRealization, route: "/program17" },
  { id: "67401e571d6ab1bd1c9c1be3", image: exploringSelf, route: "/program18" },
  { id: "67401e711d6ab1bd1c9c1be5", image: growthBuilt, route: "/program19" },
  { id: "67401e901d6ab1bd1c9c1be7", image: crafting, route: "/program20" },
  { id: "67401eb91d6ab1bd1c9c1be9", image: timeManagement, route: "/program21" },
  { id: "67401ed31d6ab1bd1c9c1beb", image: masteryInInterview, route: "/program22" },
  { id: "67401efd1d6ab1bd1c9c1bed", image: aceYouEngineering, route: "/program23" },
  { id: "67401f201d6ab1bd1c9c1bef", image: exclusiveTailored, route: "/program24" },
];

const Programs = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all programs in parallel
  useEffect(() => {
    let cancelled = false;

    async function fetchAll() {
      setLoading(true);
      try {
        const requests = PROGRAMS_META.map(({ id }) =>
          axios.get(`${baseurl}/api/programs/${id}`).then((res) => res.data)
        );
        const results = await Promise.allSettled(requests);

        const merged = results.map((r, i) => {
          const meta = PROGRAMS_META[i];
          if (r.status === "fulfilled") {
            return {
              ...r.value,
              image: meta.image,
              route: meta.route,
            };
          }
          // fallback card when one fetch fails
          return {
            _id: meta.id,
            name: "Program Unavailable",
            description: "Temporarily unavailable. Please check back later.",
            image: meta.image,
            route: meta.route,
            __error: true,
          };
        });

        if (!cancelled) setPrograms(merged);
      } catch (e) {
        if (!cancelled) console.error("Failed to fetch programs:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchAll();
    return () => {
      cancelled = true;
    };
  }, []);

  // Navigation handlers
  const onViewDetails = (program) => {
    navigate(program.route, { state: { program } });
  };

  const onBookNow = (program) => {
    // Pass minimal + safe payload; Booking page can fetch fresh details using id if needed
    const payload = {
      programId: program._id,
      name: program.name,
      description: program.description,
      image: program.image,
    };
    navigate("/booking", { state: payload }); // <-- redirect to /booking
  };

  // Derived: grid skeleton while loading
  const skeletonCount = 8;
  const gridItems = useMemo(
    () => (loading ? Array.from({ length: skeletonCount }) : programs),
    [loading, programs]
  );

  return (
    <div
      className="programs-section"
      style={{
        background: `linear-gradient(rgba(3, 7, 18, 0.65), rgba(3, 7, 18, 0.65)), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="programs-overlay">
        <header className="programs-header">
          <h1>Our Programs</h1>
          <p>Explore our programs designed for growth and success.</p>
        </header>

        {/* Responsive grid */}
        <div className="programs-grid">
          {gridItems.map((p, idx) =>
            loading ? (
              <div key={idx} className="program-card skeleton">
                <div className="program-image skeleton-box" />
                <div className="program-content">
                  <div className="skeleton-line w-70" />
                  <div className="skeleton-line w-90" />
                  <div className="skeleton-line w-50" />
                </div>
              </div>
            ) : (
              <div key={p._id || idx} className="program-card">
                <div className="program-image-wrap">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="program-image"
                    loading="lazy"
                  />
                </div>

                <div className="program-content">
                  <h3 className="program-title">{p.name}</h3>
                  <p className="program-desc">{p.description}</p>
                </div>

                <div className="program-actions">
                  <button className="program-button" onClick={() => onViewDetails(p)}>
                    View Details
                  </button>
                  <button className="program-button alt" onClick={() => onBookNow(p)}>
                    Book Now
                  </button>
                </div>

                {p.__error && (
                  <div className="program-note">
                    Couldn’t load details. Showing fallback.
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Programs;















































// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import "./program.css";
// import backgroundImage from "../assets/About2.jpg";
// import { baseurl } from "./api";

// // Assets (images)
// import nurturing from "../assets/nurturing.jpeg";
// import crafting from "../assets/crafting.jpeg";
// import selfworth from "../assets/self-worth.jpeg";
// import revitalize from "../assets/revitalize.jpeg";
// import unleashing from "../assets/unleasing-leadership.jpeg";
// import selfImprovement from "../assets/self-improvement-odyssey.jpeg";
// import confidence from "../assets/Comfidance-buster.jpeg";
// import ignitingSelfMotivation from "../assets/igniting-self-motivation.jpeg";
// import selDescipline from "../assets/self-deciplaned.jpeg";
// import igniteYourSpark from "../assets/ignite-your-spark.jpeg";
// import selfEfficancy from "../assets/self-efficiancy.jpeg";
// import fuelYourInspiration from "../assets/fuel-your-inspiration.jpeg";
// import selfEsteem from "../assets/self-esteem-enhancement.jpeg";
// import unleashYourPotential from "../assets/unlease-your-potential.jpeg";
// import selfAwareness from "../assets/self-wareness.jpeg";
// import selfLove from "../assets/self-love.jpeg";
// import selfRealization from "../assets/self-realization.jpeg";
// import exploringSelf from "../assets/exploring-self.jpeg";
// import growthBuilt from "../assets/GrowthBuilt.jpeg";
// import masteryInInterview from "../assets/masteryinterview.jpeg";
// import aceYouEngineering from "../assets/AceYourEnginnering.jpeg";
// import exclusiveTailored from "../assets/ExclusiveTailored.jpeg";
// import timeManagement from "../assets/timeManagement.jpeg";

// const PROGRAMS_META = [
//   { id: "674019611d6ab1bd1c9c1bc1", image: nurturing, route: "/program-details" },
//   { id: "674019a01d6ab1bd1c9c1bc3", image: crafting, route: "/program2" },
//   { id: "674019e01d6ab1bd1c9c1bc5", image: selfworth, route: "/program3" },
//   { id: "67401a211d6ab1bd1c9c1bc7", image: revitalize, route: "/program4" },
//   { id: "67401a441d6ab1bd1c9c1bc9", image: unleashing, route: "/program5" },
//   { id: "67401a6c1d6ab1bd1c9c1bcb", image: selfImprovement, route: "/program6" },
//   { id: "67401a921d6ab1bd1c9c1bcd", image: confidence, route: "/program7" },
//   { id: "67401ab11d6ab1bd1c9c1bcf", image: ignitingSelfMotivation, route: "/program8" },
//   { id: "67401ad11d6ab1bd1c9c1bd1", image: selDescipline, route: "/program9" },
//   { id: "67401d321d6ab1bd1c9c1bd3", image: igniteYourSpark, route: "/program10" },
//   { id: "67401d5b1d6ab1bd1c9c1bd5", image: selfEfficancy, route: "/program11" },
//   { id: "67401d791d6ab1bd1c9c1bd7", image: fuelYourInspiration, route: "/program12" },
//   { id: "67401d9a1d6ab1bd1c9c1bd9", image: selfEsteem, route: "/program13" },
//   { id: "67401dcb1d6ab1bd1c9c1bdb", image: unleashYourPotential, route: "/program14" },
//   { id: "67401dee1d6ab1bd1c9c1bdd", image: selfAwareness, route: "/program15" },
//   { id: "67401e111d6ab1bd1c9c1bdf", image: selfLove, route: "/program16" },
//   { id: "67401e3a1d6ab1bd1c9c1be1", image: selfRealization, route: "/program17" },
//   { id: "67401e571d6ab1bd1c9c1be3", image: exploringSelf, route: "/program18" },
//   { id: "67401e711d6ab1bd1c9c1be5", image: growthBuilt, route: "/program19" },
//   { id: "67401e901d6ab1bd1c9c1be7", image: crafting, route: "/program20" },
//   { id: "67401eb91d6ab1bd1c9c1be9", image: timeManagement, route: "/program21" },
//   { id: "67401ed31d6ab1bd1c9c1beb", image: masteryInInterview, route: "/program22" },
//   { id: "67401efd1d6ab1bd1c9c1bed", image: aceYouEngineering, route: "/program23" },
//   { id: "67401f201d6ab1bd1c9c1bef", image: exclusiveTailored, route: "/program24" },
// ];

// const Programs = () => {
//   const navigate = useNavigate();

//   const [programs, setPrograms] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedProgram, setSelectedProgram] = useState(null);
//   const [formData, setFormData] = useState({ name: "", mobile: "", email: "" });

//   // Fetch all programs in parallel
//   useEffect(() => {
//     let cancelled = false;

//     async function fetchAll() {
//       setLoading(true);
//       try {
//         const requests = PROGRAMS_META.map(({ id }) =>
//           axios.get(`${baseurl}/api/programs/${id}`).then((res) => res.data)
//         );
//         const results = await Promise.allSettled(requests);

//         const merged = results.map((r, i) => {
//           const meta = PROGRAMS_META[i];
//           if (r.status === "fulfilled") {
//             return {
//               ...r.value,
//               image: meta.image,
//               route: meta.route,
//             };
//           }
//           // fallback card when one fetch fails
//           return {
//             _id: meta.id,
//             name: "Program Unavailable",
//             description: "Temporarily unavailable. Please check back later.",
//             image: meta.image,
//             route: meta.route,
//             __error: true,
//           };
//         });

//         if (!cancelled) {
//           setPrograms(merged);
//         }
//       } catch (e) {
//         if (!cancelled) {
//           console.error("Failed to fetch programs:", e);
//         }
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     }

//     fetchAll();
//     return () => {
//       cancelled = true;
//     };
//   }, []);

//   // Handlers
//   const onViewDetails = (program) => {
//     navigate(program.route, { state: { program } });
//   };

//   const openModal = (program) => {
//     setSelectedProgram(program);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedProgram(null);
//     setFormData({ name: "", mobile: "", email: "" });
//   };

//   const handleChange = (e) =>
//     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         name: formData.name,
//         mobile: formData.mobile,
//         email: formData.email,
//         programName: selectedProgram?.name,
//       };
//       const response = await axios.post(`${baseurl}/api/user/register`, payload);
//       if (response.status === 201) {
//         alert("You have successfully registered in the program!");
//       }
//       closeModal();
//     } catch (error) {
//       console.error(
//         "Error registering in program:",
//         error.response?.data || error.message
//       );
//       alert("Failed to register. Please try again.");
//     }
//   };

//   // Derived: nice grid skeleton while loading
//   const skeletonCount = 8;
//   const gridItems = useMemo(
//     () => (loading ? Array.from({ length: skeletonCount }) : programs),
//     [loading, programs]
//   );

//   return (
//     <div
//       className="programs-section"
//       style={{
//         background: `linear-gradient(rgba(3, 7, 18, 0.65), rgba(3, 7, 18, 0.65)), url(${backgroundImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="programs-overlay">
//         <header className="programs-header">
//           <h1>Our Programs</h1>
//           <p>Explore our programs designed for growth and success.</p>
//         </header>

//         {/* Responsive grid */}
//         <div className="programs-grid">
//           {gridItems.map((p, idx) =>
//             loading ? (
//               <div key={idx} className="program-card skeleton">
//                 <div className="program-image skeleton-box" />
//                 <div className="program-content">
//                   <div className="skeleton-line w-70" />
//                   <div className="skeleton-line w-90" />
//                   <div className="skeleton-line w-50" />
//                 </div>
//               </div>
//             ) : (
//               <div key={p._id || idx} className="program-card">
//                 <div className="program-image-wrap">
//                   <img
//                     src={p.image}
//                     alt={p.name}
//                     className="program-image"
//                     loading="lazy"
//                   />
//                 </div>

//                 <div className="program-content">
//                   <h3 className="program-title">{p.name}</h3>
//                   <p className="program-desc">{p.description}</p>
//                 </div>

//                 <div className="program-actions">
//                   <button
//                     className="program-button"
//                     onClick={() => onViewDetails(p)}
//                   >
//                     View Details
//                   </button>
//                   <button className="program-button alt" onClick={() => openModal(p)}>
//                     Book Now
//                   </button>
//                 </div>

//                 {p.__error && (
//                   <div className="program-note">
//                     Couldn’t load details. Showing fallback. 
//                   </div>
//                 )}
//               </div>
//             )
//           )}
//         </div>

//         {/* Booking Modal */}
//         {isModalOpen && (
//           <div className="modal" role="dialog" aria-modal="true">
//             <div className="modal-content">
//               <button className="modal-close" onClick={closeModal} aria-label="Close">
//                 ✕
//               </button>
//               <h2 className="modal-title">
//                 Book Now — {selectedProgram?.name || "Program"}
//               </h2>
//               <form onSubmit={handleSubmit} className="modal-form">
//                 <label>
//                   Name
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                   />
//                 </label>
//                 <label>
//                   Mobile
//                   <input
//                     type="tel"
//                     name="mobile"
//                     value={formData.mobile}
//                     onChange={handleChange}
//                     required
//                   />
//                 </label>
//                 <label>
//                   Email
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </label>

//                 <div className="modal-buttons">
//                   <button type="submit" className="program-button">
//                     Submit
//                   </button>
//                   <button type="button" className="program-button alt" onClick={closeModal}>
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Programs;
